export const activityCodeDescriptions = {
    "P": "Pôvodca odpadu",
    "M": "Držiteľ odpadu",
    "V": "Zber odpadov vrátane mobilného zberu",
    "R": "Zhodnocovanie odpadov",
    "D": "Zneškodňovanie odpadov",
    "O": "Obchodník",
    "S": "Sprostredkovateľ",
}